'use client'
import { differenceInMinutes } from 'date-fns/differenceInMinutes'
import { differenceInSeconds } from 'date-fns/differenceInSeconds'
import { useEffect, useRef, useState } from 'react'
const timeLeft = (time: Date) => {
  const now = new Date()
  const minutesLeft = differenceInMinutes(time, now) % 60
  const secondsLeft = differenceInSeconds(time, now) % 60
  if (minutesLeft <= 0 && secondsLeft <= 0) {
    return { minutesLeft: 0, secondsLeft: 0 }
  }
  return { minutesLeft, secondsLeft }
}
const leftPadding = (num: number) => {
  if (num <= 0) return '00'
  if (num < 10) return `0${num}`
  return num.toString()
}
const Timer = ({
  dateToExpiry,
  className,
  onTimeout
}: { dateToExpiry?: Date; className?: string; onTimeout?: () => void }) => {
  if (!dateToExpiry) {
    return <div className={className}>00:00</div>
  }

  const [clockState, setClockState] = useState(timeLeft(dateToExpiry))
  const hasTimeoutBeenCalled = useRef(false)

  // biome-ignore lint/correctness/useExhaustiveDependencies: Adding the state as a dependency would lead to an infinte loop
  useEffect(() => {
    if (
      timeLeft(dateToExpiry).minutesLeft <= 0 &&
      timeLeft(dateToExpiry).secondsLeft <= 0 &&
      clockState.minutesLeft === 0 &&
      clockState.secondsLeft === 0
    ) {
      return
    }

    const interval = setInterval(() => {
      setClockState(timeLeft(dateToExpiry || new Date()))
    }, 1000)
    if (
      timeLeft(dateToExpiry).minutesLeft <= 0 &&
      timeLeft(dateToExpiry).secondsLeft <= 0
    ) {
      setClockState(timeLeft(dateToExpiry))
      clearInterval(interval)
    }
    return () => clearInterval(interval)
  }, [dateToExpiry, onTimeout])

  if (
    clockState.minutesLeft <= 0 &&
    clockState.secondsLeft <= 0 &&
    !hasTimeoutBeenCalled.current
  ) {
    hasTimeoutBeenCalled.current = true
    onTimeout?.()
  } else if (clockState.minutesLeft > 0 || clockState.secondsLeft > 0) {
    hasTimeoutBeenCalled.current = false
  }

  return (
    <div className={className} suppressHydrationWarning={true}>
      {leftPadding(clockState.minutesLeft)}:
      {leftPadding(clockState.secondsLeft)}
    </div>
  )
}

export default Timer
